<template>
  <!-- 发送消息模板设置 -->
  <div class="page_sendModelSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="templateQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="模板类型" size="small">
              <el-select v-model="templateQuery.type" placeholder="全部类型" style="width:140px" clearable>
                <el-option label="预置" :value="0"></el-option>
                <el-option label="自定义" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适用场景" size="small">
              <el-select v-model="templateQuery.sceneType" placeholder="全部场景" style="width:140px" clearable>
                <el-option v-for="x in sceneOptions" :key="x.value" :label="x.label" :value="x.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select v-model="templateQuery.status" placeholder="全部状态" style="width:140px" clearable>
                <el-option v-for="(name, key) in statusNames" :key="key" :label="name" :value="Number(key)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板名称" size="small">
              <el-input v-model.trim="templateQuery.templateName" placeholder="模板名称" style="width:180px" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button type="success" size="small" @click="searchTemplate" style="margin-right: 15px;">查询</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>发送消息模板</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="newTemplate">新增模板</el-button>
        </div>
        <el-table :data="templateRows" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="templateName" label="模板名称" min-width="170" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column label="场景" min-width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ optionLabel(sceneOptions, row.sceneType) }}</template>
          </el-table-column>
          <el-table-column label="渠道" min-width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ channelNames[row.channelType] || row.channelType }}</template>
          </el-table-column>
          <el-table-column label="类型" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.type === 0 ? '预置' : '自定义' }}</template>
          </el-table-column>
          <el-table-column label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span :class="'status-' + row.status">{{ statusNames[row.status] || row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column label="三方模板ID" min-width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.thirdPartyTemplateId || '-' }}</template>
          </el-table-column>
          <el-table-column prop="useCount" label="使用次数" min-width="100" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column label="更新时间" min-width="170" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ formatTime(row.lastUpdateTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="240">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editTemplate(row.templateId)">详情/编辑</el-button>
                <el-button type="text" size="small" @click="editRemark(row)">编辑备注</el-button>
                <el-button type="text" size="small" @click="openLogs(row.templateId)">日志</el-button>
                <el-button type="text" size="small" @click="setTemplateStatus(row.templateId, row.status === 4 ? 1 : 2)">{{ row.status === 4 ? '启用' : '停用' }}</el-button>
                <el-button type="text" size="small" @click="openAudit(row, true)">登记审核通过</el-button>
                <el-button type="text" size="small" @click="openAudit(row, false)">登记审核驳回</el-button>
                <el-button type="text" size="small" class="danger-btn" @click="setTemplateStatus(row.templateId, 3)">删除</el-button>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <span class="muted">暂无数据</span>
          </template>
        </el-table>
        <div class="block">
          <el-pagination v-if="templateTotal > 0" @current-change="templatePageChange" :current-page.sync="templateQuery.pagination.Page" :page-size="templateQuery.pagination.PageSize" layout="total, prev, pager, next, jumper" :total="templateTotal"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑备注弹窗 -->
    <el-dialog title="编辑备注" :visible.sync="remarkVisible" width="500px" class="res_dialog">
      <el-form :model="remarkForm" label-width="80px" size="small">
        <el-form-item label="备注">
          <el-input v-model.trim="remarkForm.remark" maxlength="20" show-word-limit placeholder="请输入备注（不超过20字）"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="remarkVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveRemark" :loading="remarkLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增/编辑模板弹窗 -->
    <el-dialog :title="editForm.id ? '编辑模板' : '新增模板'" :visible.sync="editVisible" width="1000px" class="res_dialog edit_dialog" :close-on-click-modal="false">
      <!-- 基本信息 -->
      <div class="section-block">
        <div class="block-title">基本信息</div>
        <el-form :model="editForm" label-width="110px" size="small" class="edit_form">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="模板名称">
                <el-input v-model.trim="editForm.templateName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="适用场景">
                <el-select v-model="editForm.sceneType" style="width:100%">
                  <el-option v-for="x in sceneOptions" :key="x.value" :label="x.label" :value="x.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="类型">
                <el-select v-model="editForm.type" style="width:100%">
                  <el-option label="预置" :value="0"></el-option>
                  <el-option label="自定义" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="操作人ID">
                <el-input v-model.trim="editForm.userId"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="说明">
                <el-input v-model.trim="editForm.description"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 渠道列表 -->
      <div class="channel-block" v-for="(channel, ci) in editForm.channels" :key="ci">
        <div class="channel-header">
          <span class="block-title">渠道 {{ ci + 1 }}</span>
          <el-button type="danger" size="mini" @click="editForm.channels.splice(ci, 1)">删除渠道</el-button>
        </div>
        <el-form :model="channel" label-width="110px" size="small" class="edit_form">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="渠道">
                <el-select v-model="channel.channelType" style="width:100%">
                  <el-option v-for="x in channelOptionsData" :key="x.value" :label="x.label" :value="x.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发送主体">
                <el-select v-model="channel.senderSubjectId" style="width:100%">
                  <el-option v-for="x in senderOptions" :key="x.Id" :label="x.Name" :value="x.Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="短信产品类型">
                <el-select v-model="channel.productType" style="width:100%">
                  <el-option v-for="x in productOptions" :key="x.value" :label="x.label" :value="x.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="第三方平台">
                <el-select v-model="channel.thirdPartyPlatform" style="width:100%">
                  <el-option v-for="x in platformOptions" :key="x.value" :label="x.label" :value="x.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="第三方模板ID">
                <el-input v-model.trim="channel.thirdPartyTemplateId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注">
                <el-input v-model.trim="channel.remark" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="模板内容">
                <el-input type="textarea" v-model="channel.content" :rows="3"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 变量表 -->
        <el-table :data="channel.variables" border size="small" style="width:100%;margin-top:8px">
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="{row}">
              {{ row.sortNo }}
            </template>
          </el-table-column>
          <el-table-column label="变量名" min-width="120" align="center">
            <template slot-scope="{row}">
              <el-input v-model.trim="row.variableName" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="来源" width="120" align="center">
            <template slot-scope="{row}">
              <el-select v-model="row.sourceType" size="mini">
                <el-option label="系统字段" :value="1"></el-option>
                <el-option label="自定义" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="系统字段编码/自定义默认值" min-width="200" align="center">
            <template slot-scope="{row}">
              <el-select v-if="row.sourceType === 1" v-model="row.systemFieldCode" size="mini" placeholder="请选择系统字段" style="width:240px">
                <el-option v-for="x in systemFieldOptions" :key="x.value" :label="x.label" :value="x.value"></el-option>
              </el-select>
              <el-input v-else v-model="row.customValue" size="mini" placeholder="默认值" style="width:240px"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column label="第三方变量名" min-width="100" align="center">
            <template slot-scope="{row}">
              <el-input v-model.trim="row.thirdPartyVarName" size="mini" placeholder="如 param1"></el-input>
            </template>
          </el-table-column> -->
          <el-table-column label="最大长度" min-width="100" align="center">
            <template slot-scope="{row}">
              <el-input-number v-model="row.maxLength" size="mini" :min="0" :precision="0" controls-position="right" style="width:90px"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" class="danger-btn" @click="removeVariable(channel, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="text" size="small" @click="addVariable(channel)" style="margin-top:8px">增加变量</el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取消</el-button>
        <el-button size="small" @click="addChannel">增加渠道</el-button>
        <el-button type="primary" size="small" @click="saveDraft" :loading="editLoading">保存草稿</el-button>
        <el-button type="success" size="small" :disabled="!editForm.id" @click="submitAudit">提交审核</el-button>
      </span>
    </el-dialog>

    <!-- 登记审核弹窗 -->
    <el-dialog :title="auditForm.approved ? '登记审核通过' : '登记审核驳回'" :visible.sync="auditVisible" width="500px" class="res_dialog" append-to-body>
      <el-form :model="auditForm" label-width="120px" size="small">
        <el-form-item label="第三方模板ID" v-if="auditForm.approved">
          <el-input v-model.trim="auditForm.thirdPartyTemplateId"></el-input>
        </el-form-item>
        <el-form-item :label="auditForm.approved ? '审核意见' : '驳回原因'">
          <el-input type="textarea" v-model="auditForm.auditRemark" :rows="3"></el-input>
        </el-form-item>
        <!-- <el-form-item label="操作人ID">
          <el-input v-model.trim="auditForm.userId"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="auditVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="recordAudit" :loading="auditLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 发送日志弹窗 -->
    <el-dialog title="发送日志" :visible.sync="logsVisible" width="900px" class="res_dialog logs_dialog" append-to-body>
      <el-table :data="logsData" border size="small" v-loading="logLoading" style="width:100%" max-height="400">
        <el-table-column label="发送时间" min-width="160" align="center">
          <template slot-scope="{row}">{{ formatTime(row.sendTime) }}</template>
        </el-table-column>
        <el-table-column label="发送人" min-width="100" align="center">
          <template slot-scope="{row}">{{ row.senderName || '-' }}</template>
        </el-table-column>
        <el-table-column label="收件人" min-width="150" align="center">
          <template slot-scope="{row}">{{ row.recipientName || '-' }} {{ row.recipient }}</template>
        </el-table-column>
        <el-table-column label="状态" min-width="90" align="center">
          <template slot-scope="{row}">{{ sendStatusNames[row.sendStatus] || row.sendStatus }}</template>
        </el-table-column>
        <el-table-column label="失败原因" min-width="120" align="center">
          <template slot-scope="{row}">{{ row.failureReason || '-' }}</template>
        </el-table-column>
        <el-table-column label="内容" min-width="200" :show-overflow-tooltip="true">
          <template slot-scope="{row}">{{ row.sendContent }}</template>
        </el-table-column>
        <template slot="empty">
          <span class="muted">暂无数据</span>
        </template>
      </el-table>
      <div class="block" style="margin-top:12px">
        <el-pagination v-if="logTotal > 0" @current-change="logPageChange" :current-page.sync="logQuery.pagination.Page" :page-size="logQuery.pagination.PageSize" layout="total, prev, pager, next, jumper" :total="logTotal"></el-pagination>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission'
  export default {
    data() {
      return {
        loading: false,
        templateRows: [],
        templateTotal: 0,
        templateQuery: {
          type: '',
          sceneType: null,
          templateName: '',
          status: '',
          pagination: {
            Page: 1,
            PageSize: 10
          }
        },
        statusNames: {
          0: '草稿',
          1: '待审核',
          2: '已启用',
          3: '已驳回',
          4: '已停用'
        },
        channelNames: {
          1: '短信',
          2: '微信公众号'
        },
        sceneOptions: [{
            value: 1,
            label: '面试'
          },
          {
            value: 2,
            label: '面试通过'
          },
          {
            value: 3,
            label: '录用/报到'
          },
          {
            value: 4,
            label: '其他'
          }
        ],
        remarkVisible: false,
        remarkLoading: false,
        remarkForm: {
          templateId: '',
          channelId: '',
          remark: '',
          userId: ''
        },
        editVisible: false,
        editLoading: false,
        editForm: {},
        channelOptionsData: [{
            value: 1,
            label: '短信'
          },
          {
            value: 2,
            label: '微信公众号'
          }
        ],
        senderOptions: [{
          Name: '宁波杰博人力',
          Id: 1
        }, {
          Name: '宁波英普瑞特供应链管理',
          Id: 2
        }],
        productOptions: [{
            value: 1,
            label: '通知短信'
          },
          {
            value: 2,
            label: '营销短信'
          },
          {
            value: 3,
            label: '验证码短信'
          },
          {
            value: 4,
            label: '电商'
          },
          {
            value: 5,
            label: '金融'
          },
          {
            value: 6,
            label: '游戏'
          },
          {
            value: 7,
            label: '拉新'
          }
        ],
        platformOptions: [{
            value: 1,
            label: '创蓝'
          },
          {
            value: 2,
            label: '腾讯云'
          }
        ],
        systemFieldOptions: [{
            value: 'Candidate.Name',
            label: '候选人姓名'
          },
          {
            value: 'Candidate.Mobile',
            label: '候选人手机号'
          },
          {
            value: 'Offer.PositionName',
            label: '岗位名称'
          },
          {
            value: 'Interview.Time',
            label: '面试时间'
          },
          {
            value: 'Interview.Address',
            label: '面试地址'
          },
          {
            value: 'Interview.AddressUrl',
            label: '面试地址链接'
          },
          {
            value: 'Offer.ReportTime',
            label: '报到时间'
          },
          {
            value: 'Offer.ReportAddress',
            label: '报到地点'
          },
          {
            value: 'Offer.Contact',
            label: '联系人'
          },
          {
            value: 'Offer.ContactPhone',
            label: '联系电话'
          },
          {
            value: 'Offer.Remark',
            label: '备注'
          },
          {
            value: 'Project.Id',
            label: '项目ID'
          }
        ],
        auditVisible: false,
        auditLoading: false,
        auditForm: {
          approved: true,
          thirdPartyTemplateId: '',
          auditRemark: '',
          userId: ''
        },
        logsVisible: false,
        logLoading: false,
        logsData: [],
        logTotal: 0,
        logQuery: {
          templateId: '',
          pagination: {
            Page: 1,
            PageSize: 50
          }
        },
        sendStatusNames: {
          0: '待回执',
          1: '成功',
          2: '失败'
        },
      }
    },
    created() {
      this.loadTemplatePage();
    },
    methods: {
      checkPermission,
      searchTemplate() {
        this.templateQuery.pagination.Page = 1;
        this.loadTemplatePage();
      },
      templatePageChange(val) {
        this.templateQuery.pagination.Page = Number(val);
        this.loadTemplatePage();
      },
      loadTemplatePage() {
        this.loading = true;
        let query = JSON.parse(JSON.stringify(this.templateQuery));
        ['type', 'status', 'sceneType'].forEach(k => {
          if (query[k] === '' || query[k] === null) query[k] = null;
        });
        xz.messageFun(query, 'GetPage').then(res => {
          if (res && res.status === 'ok') {
            let d = res.data || {};
            this.templateRows = d.items || d.Items || d.data || d.Data || [];
            this.templateTotal = d.total || d.Total || d.totalCount || d.TotalCount || this.templateRows.length;
          } else {
            this.templateRows = [];
            this.templateTotal = 0;
          }
          this.loading = false;
        }).catch(() => {
          this.templateRows = [];
          this.templateTotal = 0;
          this.loading = false;
        });
      },
      formatTime(v) {
        return v ? new Date(v).toLocaleString() : '-';
      },
      optionLabel(options, value) {
        let item = options.find(x => x.value === Number(value));
        return item ? item.label : value;
      },
      newTemplate() {
        this.editForm = {
          id: null,
          templateName: '',
          sceneType: 1,
          description: '',
          type: 1,
          userId: Cookies.get("userid-b"),
          channels: [this.blankChannel()]
        };
        this.editVisible = true;
      },
      editTemplate(id) {
        xz.messageGetFun('GetDetail?TemplateId=' + id, 'get').then(res => {
          if (res && res.status === 'ok') {
            this.editForm = this.normalizeDetail(JSON.parse(JSON.stringify(res.data)));
            this.editForm.userId = Cookies.get("userid-b");
            this.editVisible = true;
          } else {
            this.$message.error(res.msg || '获取详情失败');
          }
        });
      },
      enumValue(value, map) {
        if (typeof value === 'number') return value;
        if (value !== null && value !== '' && !isNaN(Number(value))) return Number(value);
        let key = Object.keys(map).find(x => x.toLowerCase() === String(value).toLowerCase());
        return key !== undefined ? map[key] : value;
      },
      normalizeDetail(data) {
        let self = this;
        data.type = this.enumValue(data.type, {
          Preset: 0,
          Custom: 1
        });
        data.status = this.enumValue(data.status, {
          Draft: 0,
          PendingThirdPartyAudit: 1,
          Approved: 2,
          Rejected: 3,
          Disabled: 4
        });
        data.channels = (data.channels || []).map(function (channel) {
          channel.channelType = self.enumValue(channel.channelType, {
            Sms: 1,
            WeChatOfficialAccount: 2
          });
          channel.productType = self.enumValue(channel.productType, {
            Notify: 1,
            Market: 2,
            Verify: 3,
            International: 4,
            Finance: 5,
            Game: 6,
            Acquisition: 7
          });
          channel.thirdPartyPlatform = self.enumValue(channel.thirdPartyPlatform, {
            ChuangLan: 1,
            TencentCloud: 2
          });
          channel.variables = (channel.variables || []).map(function (variable) {
            variable.sourceType = self.enumValue(variable.sourceType, {
              SystemField: 1,
              CustomValue: 2
            });
            return variable;
          }).sort(function (a, b) {
            return (a.sortNo || 0) - (b.sortNo || 0);
          });
          return channel;
        });
        return data;
      },
      blankChannel() {
        return {
          id: null,
          channelType: 1,
          senderSubjectId: 1,
          productType: 1,
          content: '',
          thirdPartyPlatform: 1,
          thirdPartyTemplateId: '',
          remark: '',
          variables: []
        };
      },
      blankVariable(i) {
        return {
          id: null,
          variableName: '',
          sourceType: 1,
          systemFieldCode: '',
          customValue: '',
          thirdPartyVarName: 'param' + i,
          maxLength: 0,
          sortNo: i
        };
      },
      addChannel() {
        this.editForm.channels.push(this.blankChannel());
      },
      addVariable(channel) {
        channel.variables.push(this.blankVariable(channel.variables.length + 1));
      },
      removeVariable(channel, index) {
        channel.variables.splice(index, 1);
        channel.variables.forEach((item, i) => {
          item.sortNo = i + 1;
        });
      },
      saveDraft() {
        this.editLoading = true;
        xz.messageFun(this.editForm, 'SaveDraft').then(res => {
          this.editLoading = false;
          if (res && res.status === 'ok') {
            if (!this.editForm.id && res.data) this.editForm.id = res.data;
            this.$message.success(res.msg || '保存成功');
            this.loadTemplatePage();
          } else {
            this.$message.error(res.msg || '保存失败');
          }
        }).catch(() => {
          this.editLoading = false;
        });
      },
      submitAudit() {
        xz.messageFun({
          templateId: this.editForm.id,
          userId: this.editForm.userId
        }, 'SubmitThirdPartyAudit').then(res => {
          if (res && res.status === 'ok') {
            this.$message.success(res.msg || '提交成功');
            this.loadTemplatePage();
          } else {
            this.$message.error(res.msg || '提交失败');
          }
        });
      },
      openAudit(row, approved) {
        this.auditForm = {
          templateId: row.templateId,
          channelId: row.channelId,
          approved: approved,
          thirdPartyTemplateId: '',
          auditRemark: '',
          userId: Cookies.get("userid-b")
        };
        this.auditVisible = true;
      },
      recordAudit() {
        this.auditLoading = true;
        xz.messageFun({
          templateId: this.auditForm.templateId,
          channelId: this.auditForm.channelId,
          approved: this.auditForm.approved,
          thirdPartyTemplateId: this.auditForm.approved ? this.auditForm.thirdPartyTemplateId : null,
          auditRemark: this.auditForm.auditRemark,
          userId: this.auditForm.userId
        }, 'SetThirdPartyAuditResult').then(res => {
          this.auditLoading = false;
          if (res && res.status === 'ok') {
            this.$message.success(res.msg || '保存成功');
            this.auditVisible = false;
            this.loadTemplatePage();
          } else {
            this.$message.error(res.msg || '保存失败');
          }
        }).catch(() => {
          this.auditLoading = false;
        });
      },
      editRemark(row) {
        xz.messageGetFun('GetRemarkDetail?TemplateId=' + row.templateId + '&ChannelId=' + row.channelId, 'get').then(res => {
          if (res && res.status === 'ok') {
            this.remarkForm = {
              templateId: row.templateId,
              channelId: row.channelId,
              remark: (res.data && res.data.remark) || '',
              userId: Cookies.get("userid-b")
            };
            this.remarkVisible = true;
          } else {
            this.$message.error(res.msg || '获取备注失败');
          }
        });
      },
      saveRemark() {
        if (this.remarkForm.remark.length > 20) {
          this.$message.error('备注不能超过20个字');
          return;
        }
        this.remarkLoading = true;
        xz.messageFun({
          templateId: this.remarkForm.templateId,
          channelId: this.remarkForm.channelId,
          remark: this.remarkForm.remark,
          userId: this.remarkForm.userId
        }, 'SaveRemark').then(res => {
          this.remarkLoading = false;
          if (res && res.status === 'ok') {
            this.$message.success(res.msg || '保存成功');
            this.remarkVisible = false;
            this.loadTemplatePage();
          } else {
            this.$message.error(res.msg || '保存失败');
          }
        }).catch(() => {
          this.remarkLoading = false;
        });
      },
      openLogs(id) {
        this.logQuery.templateId = id || '';
        this.logQuery.pagination.Page = 1;
        this.logsVisible = true;
        this.loadLogs();
      },
      logPageChange(val) {
        this.logQuery.pagination.Page = Number(val);
        this.loadLogs();
      },
      loadLogs() {
        this.logLoading = true;
        xz.messageFun(this.logQuery, 'GetLogPage').then(res => {
          if (res && res.status === 'ok') {
            let d = res.data || {};
            this.logsData = d.items || d.Items || d.data || d.Data || [];
            this.logTotal = d.total || d.Total || d.totalCount || d.TotalCount || this.logsData.length;
          } else {
            this.logsData = [];
            this.logTotal = 0;
          }
          this.logLoading = false;
        }).catch(() => {
          this.logsData = [];
          this.logTotal = 0;
          this.logLoading = false;
        });
      },
      setTemplateStatus(id, op) {
        if (op === 3 && !confirm('确定删除该模板吗？')) return;
        xz.messageFun({
          templateId: id,
          operation: op,
          userId: Cookies.get("userid-b")
        }, 'SetStatus').then(res => {
          if (res && res.status === 'ok') {
            this.$message.success(res.msg || '操作成功');
            this.loadTemplatePage();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .muted {
    color: #909399;
  }

  .status-0 {
    color: #909399;
  }

  .status-1 {
    color: #e6a23c;
  }

  .status-2 {
    color: #67c23a;
  }

  .status-3,
  .status-4 {
    color: #f56c6c;
  }

  .section-block {
    margin-bottom: 18px;
  }

  .channel-block {
    margin-top: 14px;
    padding: 14px;
    border: 1px dashed #c0c4cc;
    border-radius: 5px;
  }

  .channel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .block-title {
    font-weight: bold;
    font-size: 15px;
  }

  .edit_dialog .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
  }
</style>
<style>
  .page_sendModelSet .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_sendModelSet .injuryTabBtn .danger-btn {
    color: #f56c6c;
  }

  .page_sendModelSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_sendModelSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_sendModelSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }
</style>